import { render, staticRenderFns } from "./right-tool.vue?vue&type=template&id=ad08f97c&scoped=true"
import script from "./right-tool.vue?vue&type=script&lang=js"
export * from "./right-tool.vue?vue&type=script&lang=js"
import style0 from "./right-tool.vue?vue&type=style&index=0&id=ad08f97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad08f97c",
  null
  
)

export default component.exports